/* eslint-disable react/prop-types */
import React, {ReactElement} from 'react';
import Footer from '../../components/Footer';
import './index.scss';

const OrganizerLayoutWrapper: React.FC = ({children}): ReactElement => {
  return (
    <div className="organizerLayoutWrapper">
      {children}
      <Footer />
    </div>
  );
};

export default OrganizerLayoutWrapper;
